// extracted by mini-css-extract-plugin
export var banner = "_qc-0";
export var settingRow = "_qc-2";
export var titleIcon = "_qc-1";